<template>
	<div>
		<aBox>
			<div slot="body">
				<osFilter ref="filter" @updateTab="filter" />
			</div>
		</aBox>
		<aBox title="Ordem de serviços">
			<div slot="tools">
				<button class="btn btn-default btn-sm">
					{{ depto.titulo }}
				</button>
				<botan-para-trocar-modo-da-view v-model="view" />
			</div>
			<div slot="body" :class="`mode-${view}`">
				<mode-smart-table
					v-if="view == 'table'"
					ref="view"
					:preRequestData="preRequestData"
					:totalRegistros="totalRegistros"
				/>
				<mode-agroup
					v-else
					ref="view"
					:preRequestData="preRequestData"
					:totalRegistros="totalRegistros"
				/>
				<!-- <grafic-mode
          :preRequestData='preRequestData'
          :totalRegistros='totalRegistros'
        /> -->
			</div>
		</aBox>

		<sPager
			:registros="totalRegistros"
			:qnt="header.pager.qnt"
			v-model="header.pager.page"
			@uQnt="(val) => (header.pager.qnt = val)"
			@updateTable="update"
		/>

		<CmpForm ref="compForm" @updateTable="(ev) => $refs.view.update()" />
	</div>
</template>
<script>
	import aBox from 'box';
	import WBS from 'js/http';
	import toastr from 'toastr';

	import sPager from '../../app-components/table/paginator.vue';

	import osFilter from './components/filter.vue';
	import CmpForm from './components/comp.forms.vue';
	import BotanParaTrocarModoDaView from './components/BotanParaTrocarModoDaView.vue';

	import ModeSmartTable from './components/ModeSmartTable/index.vue';
	import ModeAgroup from './components/ModeAgroup/index.vue';
	import GraficMode from './components/GraficMode/index.vue';

	import { mapState } from 'vuex';
	import loader from './js/loader.js';
	import LoadFunctions from './js/loadFunctions.mixin.js';

	export default {
		name: 'MainServiceOrder',
		mixins: [LoadFunctions],
		components: {
			aBox,
			sPager,
			osFilter,
			CmpForm,
			ModeSmartTable,
			ModeAgroup,
			BotanParaTrocarModoDaView,
			GraficMode,
		},
		data() {
			return {
				view: 'table',
				assets: {
					enquadramento_cipa: null,
					grupos: null,
					relacionamento_cnae_cipa: null,
					grau_de_risco: null,
					tecnicos: null,
					sForms: null,
					regioes: null,
				},
			};
		},
		provide() {
			let assets = {};
			for (let asset in this.assets) {
				Object.defineProperty(assets, asset, {
					enumerable: true,
					get: () => this.assets[asset],
				});
			}
			return {
				assets: assets,
				update: (calback) => this.requestServer(calback),
				IsolarCliente: (cnpj) => this.$refs.filter.IsolarCliente(cnpj),
				GetClientData: (cnpj) => this.GetClientDataFX(cnpj),
			};
		},
		computed: {
			...mapState({
				depto: (s) => s.user_data.uid.departamento,
			}),
		},
		mounted() {
			this.$emit('setHeader', ['Ordem de serviço', '']);
			WBS.send('protected-read-assetsMdMapeamento', (resp) => {
				if (resp.status == 'success') {
					this.assets = resp.data;
					this.$refs.filter.update();
				}
			});
			WBS.send('protected-read-assetsPropostas', (resp) => {
				if (resp.status == 'success' && resp.data != undefined) {
					this.regioes = resp.data.regioes;
				}
			});
		},
	};
</script>
<style scoped>
	.mode-indent {
		background: #ecf0f5;
	}
	.mode-indent,
	.mode-table {
		display: block;
		margin: -10px -10px -30px -10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/index.vue